// Real Estate agent records — docs/real-estate/be/10-api-reference.md §A6.
// Agents have no active/inactive status of their own; the project-side
// assignment (setProjectAgents in store/modules/realEstate.js) is what
// controls whether one can be booked for a given project.
import {
  listAgents,
  createAgent,
  patchAgent,
  deleteAgent,
} from '../../api/realEstate/agents';
import { listAllPages } from '../../api/realEstate/pagination';

export const state = {
  // Every agent (all pages) — agent counts stay small, and every dropdown
  // and the Agents page need the full set.
  agents: [],
  uiFlags: {
    isFetching: false,
  },
};

export const mutations = {
  setAgents(moduleState, agents) {
    moduleState.agents = agents;
  },
  removeAgent(moduleState, agentId) {
    moduleState.agents = moduleState.agents.filter(a => a.agent_id !== agentId);
  },
  setUiFlag(moduleState, { key, value }) {
    moduleState.uiFlags = { ...moduleState.uiFlags, [key]: value };
  },
};

export const getters = {
  getAgents: moduleState => moduleState.agents,
  getUiFlags: moduleState => moduleState.uiFlags,
};

export const actions = {
  async fetchAgents({ commit }, query) {
    commit('setUiFlag', { key: 'isFetching', value: true });
    try {
      const agents = await listAllPages(listAgents, query);
      commit('setAgents', agents);
      return agents;
    } finally {
      commit('setUiFlag', { key: 'isFetching', value: false });
    }
  },
  async addAgent({ dispatch }, fields) {
    const { data } = await createAgent(fields);
    await dispatch('fetchAgents');
    return data;
  },
  async updateAgent({ dispatch }, { agentId, fields }) {
    const { data } = await patchAgent(agentId, fields);
    await dispatch('fetchAgents');
    return data;
  },
  async removeAgent({ commit }, agentId) {
    await deleteAgent(agentId);
    commit('removeAgent', agentId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
